module.exports = __webpack_public_path__ + "img/sales_store_checkout.9432b683.svg";